<template lang="pug">
  v-layout(align-start)
    v-flex
      v-card.pa-5.mb-2(width='96vw' outlined)
        h1.text-uppercase.text-center(align='center') Indicadores de Gestión
        v-row(dense)
          v-icon info
          h5 *Las graficas se mostraran si elige un rango mayor o igual 3 dias
        v-flex(d-flex flex-wrap justify-space-between mb-5)
          v-flex(xs12 sm3 md3)
            v-select(v-model="selectedDate" dense outlined :items="seleccionarFecha" label="Selecionar Rango" @change='changeFecha')
          v-flex(xs12 sm3 md3)
            v-dialog(ref='dialog1' v-model='modalDate1' :return-value.sync='date' readonly persistent width='300px')
              template(v-slot:activator='{ on }')
                v-text-field( v-model='fechaDesde' label='Desde' prepend-icon='event' readonly dense outlined v-on='on' :max='date')
              v-date-picker(:max='date' v-model='fechaDesde' locale="ES" )
                v-spacer
                v-btn(small dark color='red' @click='modalDate1 = false') Cancelar
                v-btn(small dark color='success' @click='$refs.dialog1.save(date)') Ok
          v-flex(xs12 sm3 md3)
            v-dialog(ref='dialog2' v-model='modalDate2' :return-value.sync='date' readonly persistent width='300px')
              template(v-slot:activator='{ on }')
                v-text-field( v-model='fechaHasta' label='Hasta' prepend-icon='event' readonly dense outlined v-on='on' :max='date')
              v-date-picker(:max='date' v-model='fechaHasta' locale="ES")
                v-spacer
                v-btn(small dark color='red' @click='modalDate2 = false') Cancelar
                v-btn(small dark color='success' @click='$refs.dialog2.save(date)') Ok
          v-flex(xs12 sm2 md2)
            v-btn(@click='buscar' color='primary' dark width="100%") PROCESAR
        
        v-flex(d-flex flex-wrap justify-space-between)

          v-flex(xs12 sm5 md5 my-3)
            v-card.mx-auto(color='white' width='100%' :loading='loading')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white")
                p.subtitle-1.text-nowrap Total de ventas realizadas 
              v-card-text.pa-0 
                v-row(align="center" justify="center"  v-if='totalVentasRealizadas.total > 0') 
                  v-col(cols=12).display-2.text-center.font-weight-bold {{ totalVentasRealizadas.total}}
                  v-col(cols=12)
                    #chart(v-if="graficas")
                      apexchart(
                      class="algo"
                      style="width:100%"
                      v-show='rango >= 3'
                      type="line",
                      width='100%',
                      height="90%",
                      :series="totalVentasRealizadas.series",
                      :options="totalVentasRealizadas.chartOptions")  
                v-row(align="center" justify="center" v-else)
                  p.display-2.text-center 0

          v-flex(xs12 sm5 md5 my-3)
            v-card.mx-auto(color='white' width='100%' :loading='loading')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white") 
                p.subtitle-1 Monto Total Vendido
              v-card-text.headline 
                v-row(align="center" justify="center"  v-if='montoTotalVendido.total > 0') 
                  v-col.display-2.text-center.font-weight-bold.green--text(cols=12) {{ montoTotalVendido.total}} 
                  v-col(cols=12)
                    #chart(v-if="graficas")
                      apexchart(
                      v-show='rango > 3'
                      style="width:100%"
                      type="line",
                      width='100%',
                      height="90%",
                      :series="montoTotalVendido.series",
                      :options="montoTotalVendido.chartOptions")
                v-row(align="center" justify="center" v-else).display-2.text-center 0    

          v-flex(xs12 sm5 md5 my-3)
            v-card.mx-auto(color='white' width='100%' :loading='loading')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white")
                p.subtitle-1.text-nowrap Total de Notas de Entrega realizadas 
              v-card-text.pa-0 
                v-row(align="center" justify="center"  v-if='totalVentasRealizadas.total > 0') 
                  v-col(cols=12).display-2.text-center.font-weight-bold {{ totalNotasEntregaRealizadas.total}}
                  v-col(cols=12)
                    #chart(v-if="graficas")
                      apexchart(
                      class="algo"
                      style="width:100%"
                      v-show='rango >= 3'
                      type="line",
                      width='100%',
                      height="90%",
                      :series="totalNotasEntregaRealizadas.series",
                      :options="totalNotasEntregaRealizadas.chartOptions")  
                v-row(align="center" justify="center" v-else)
                  p.display-2.text-center 0

          v-flex(xs12 sm5 md5 my-3)
            v-card.mx-auto(color='white' width='100%' :loading='loading')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white")
                p.subtitle-1.text-nowrap Ganancias
              v-card-text.pa-0
                //- v-row(align="center" justify="center" v-if='totalVentasRealizadas.total > 0') 
                //-   div
                //-     h3
                //-       | Costo de lo Vendido : {{ ganancias.costoVendido }}
                //-     br
                //-     h3  
                //-       | Monto Total Vendido : {{ ganancias.totalVendido }}                
                v-row(align="center" justify="center"  v-if='totalVentasRealizadas.total > 0') 
                  v-col(cols=12)
                    #chart(v-if="graficas")
                      apexchart(
                      class="algo"
                      style="width:100%"
                      type="bar",
                      width='100%',
                      height="90%",
                      :series="ganancias.series",
                      :options="ganancias.chartOptions")  
                v-row(align="center" justify="center" v-else)
                  p.display-1.text-center No hay información para mostrar

          v-flex(xs12 sm5 md5 my-3)
            v-card.mx-auto(color='white' width='100%' :loading='loading')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white") 
                p.subtitle-1 10 Productos mas vendidos
              v-card-text
                v-list(dense v-if='productosMasVendidos.length > 0')
                  template(v-for='(producto, i) in productosMasVendidos')
                    v-divider(:key="i" v-if='i > 0' inset=true) 
                    v-list-item(:key='producto._id')
                      v-list-item-avatar
                        v-icon(v-text="numbersPosition[i]")
                      v-list-item-content
                        v-list-item-title(v-text="producto.nombre")
                        v-divider
                      v-list-item-action
                        v-chip.ma-2 {{ producto.totalVendido }}
                v-row(align="center" justify="center" v-else)
                  p.display-1.text-center No hay información para mostrar 

          v-flex(xs12 sm5 md5 my-3) 
            v-card.mx-auto(color='white' width='100%' :loading='loading')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white") 
                p.subtitle-1 10 Productos menos vendidos
              v-card-text
                v-list(dense v-if='productosMenosVendidos.length > 0')
                  template(v-for='(producto, i) in productosMenosVendidos')
                    v-divider(:key="i" v-if='i > 0' inset=true) 
                    v-list-item(:key='producto._id')
                      v-list-item-avatar
                        v-icon(v-text="numbersPosition[i]")
                      v-list-item-content
                        v-list-item-title(v-text="producto.nombre")
                        v-divider
                      v-list-item-action
                        v-chip.ma-2 {{ producto.totalVendido }}
                v-row(align="center" justify="center" v-else)
                  p.display-1.text-center No hay información para mostrar 

          v-flex(xs12 sm5 md5 my-3)
            v-card.mx-auto(color='white' width='100%' :loading='loading')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white") 
                p.subtitle-1 
                  |Productos con existencia
                  br 
                  |menor o igual al stock minimo
              v-card-text     
                v-list(v-if='stock.length > 0' dense)
                  template(v-for='(producto, i) in stock')
                    v-divider(:key="i" v-if='i > 0' inset=true) 
                    v-list-item(:key='producto._id')
                      v-list-item-avatar
                        v-icon(v-text="numbersPosition[i]")
                      v-list-item-content
                        v-list-item-title(v-text="producto.idProducto.nombre")
                        v-divider
                      v-list-item-action
                        v-chip.ma-2 {{ producto.stockActual }}
                v-row(align="center" justify="center" v-else)
                  p.display-1.text-center No hay información para mostrar        

          v-flex(xs12 sm5 md5 my-3)
            v-card.mx-auto(color='white' width='100%' :loading='loadingInicio')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white")
                p.subtitle-1.text-nowrap Crecimiento de ventas
              v-card-text.pa-0 
                v-flex(v-if='!loadingInicio')
                  v-row.pt-2(align="center" justify="center")
                    h2 Monto Vendido
                  v-row.pa-5(align="center" justify="center")
                    v-col(cols=12 xs=12 md=6 align-self='center')
                      v-row(align="center" justify="center")
                        div
                          h3
                            | Mes Actual : {{ crecimientoMes.meses[0].montoVendido }}
                          br
                          h3  
                            | Mes Pasado : {{ crecimientoMes.meses[1].montoVendido }}
                    
                    v-col(cols=12 xs=12 md=6 align-self='center')
                      v-row(v-if='crecimientoMes.porcMontos > 0' align="center" justify="center")
                        v-icon(color='green') mdi-arrow-top-right-thick
                        h2.ganancia.display-1 {{ Number.parseFloat(crecimientoMes.porcMontos).toFixed(2)  }} %
                      v-row(v-else-if='crecimientoMes.porcMontos < 0')
                        v-icon(color='red') mdi-arrow-bottom-right-thick
                        h2.perdida.display-1 {{ Number.parseFloat(crecimientoMes.porcMontos).toFixed(2)  }} %
                      v-row(v-else)
                        v-icon(color='green') mdi-info
                        h3.perdida No existe informacion del mas pasado para comparar
                  
                  v-divider
                  v-row.pt-2(align="center" justify="center")
                    h2 Total Ventas Realizadas      
                  v-row.pa-5(align="center" justify="center")
                    v-col(cols=12 xs=12 md=6 align-self='center')
                      v-row(align="center" justify="center")
                        div 
                          h3
                            | Mes Actual : {{ crecimientoMes.meses[0].totalFacturas }}
                          br
                          h3
                            | Mes Pasado : {{ crecimientoMes.meses[1].totalFacturas }}
                    v-col(cols=12 xs=12 md=6 align-self='center')
                      v-row(v-if='crecimientoMes.porcFacturas > 0' align="center" justify="center")
                        v-icon(color='green') mdi-arrow-top-right-thick
                        h2.ganancia.display-1 {{ Number.parseFloat(crecimientoMes.porcFacturas).toFixed(2)  }} %
                      v-row.text-center(v-else-if='crecimientoMes.porcFacturas < 0')
                        v-icon(color='red') mdi-arrow-bottom-right-thick
                        h2.perdida.display-1 {{ Number.parseFloat(crecimientoMes.porcFacturas).toFixed(2)  }} %                      
                      v-row(v-else)
                        v-icon(color='green') mdi-info
                        h3.perdida No existe informacion del mas pasado para comparar 
                  
          v-flex(xs12 sm5 md5 my-3)
            v-card.mx-auto(color='white' width='100%' :loading='loading')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white")
                p.subtitle-1.text-nowrap Total de Notas de Debito realizadas 
              v-card-text.pa-0 
                v-row(align="center" justify="center"  v-if='totalNotasDebito.total > 0') 
                  v-col(cols=12).display-2.text-center.font-weight-bold {{ totalNotasDebito.total}}
                  v-col(cols=12)
                    #chart(v-if="graficas")
                      apexchart(
                      class="algo"
                      style="width:100%"
                      v-show='rango >= 3'
                      type="line",
                      width='100%',
                      height="90%",
                      :series="totalNotasDebito.series",
                      :options="totalNotasDebito.chartOptions")  
                v-row(align="center" justify="center" v-else)
                  p.display-2.text-center 0

          v-flex(xs12 sm5 md5 my-3)
            v-card.mx-auto(color='white' width='100%' :loading='loading')
              v-card-title.pb-0.text-uppercase.text-center.justify-center(style="background-color:#26A69A; color:white")
                p.subtitle-1.text-nowrap Total de Notas de Credito realizadas 
              v-card-text.pa-0 
                v-row(align="center" justify="center"  v-if='totalNotasCredito.total > 0') 
                  v-col(cols=12).display-2.text-center.font-weight-bold {{ totalNotasCredito.total}}
                  v-col(cols=12)
                    #chart(v-if="graficas")
                      apexchart(
                      class="algo"
                      style="width:100%"
                      v-show='rango >= 3'
                      type="line",
                      width='100%',
                      height="90%",
                      :series="totalNotasCredito.series",
                      :options="totalNotasCredito.chartOptions")  
                v-row(align="center" justify="center" v-else)
                  p.display-2.text-center 0                  
</template>

<script>
import Api from "@/services/methods";
export default {
  data: () => ({
    dialog1: false,
    dialog2: false,
    modalDate1: false,
    modalDate2: false,
    date: new Date().toISOString().substr(0, 10),
    fechaDesde: "",
    fechaHasta: "",
    graficas: true,
    rango: 0,
    loading: false,
    loadingInicio: true,
    seleccionarFecha: [
      {
        text: "Hoy",
        value: 1
      },
      {
        text: "Ayer",
        value: 2
      },
      {
        text: "Últimos 7 días",
        value: 3
      },
      {
        text: "Últimos 30 días",
        value: 4
      },
      {
        text: "Fecha Personalizada",
        value: 5
      }
    ],
    selectedDate: 0,

    numbersPosition: [
      "mdi-numeric-1-circle",
      "mdi-numeric-2-circle",
      "mdi-numeric-3-circle",
      "mdi-numeric-4-circle",
      "mdi-numeric-5-circle",
      "mdi-numeric-6-circle",
      "mdi-numeric-7-circle",
      "mdi-numeric-8-circle",
      "mdi-numeric-9-circle",
      "mdi-numeric-10-circle"
    ],

    productosMasVendidos: [],

    productosMenosVendidos: [],

    totalVentasRealizadas: {
      total: 0,
      series: [
        {
          name: "Total Vendido",
          data: []
        }
      ],
      chartOptions: {
        chart: {
          height: "100%",
          width: "100%",
          type: "line"
        },
        xaxis: {
          type: "datetime"
        },
        dataLabels: {
          enabled: true,
          position: 'top'
        },
        stroke: {
          curve: 'smooth'
        },
      }
    },

    totalNotasEntregaRealizadas: {
      total: 0,
      series: [
        {
          name: "Total Vendido",
          data: []
        }
      ],
      chartOptions: {
        chart: {
          height: "100%",
          width: "100%",
          type: "line"
        },
        xaxis: {
          type: "datetime"
        },
        dataLabels: {
          enabled: true,
          position: 'top'
        },
        stroke: {
          curve: 'smooth'
        },
      }
    },

    montoTotalVendido: {
      total: 0,
      series: [
        {
          name: "Monto Vendido",
          data: []
        }
      ],
      chartOptions: {
        chart: {
          height: "100%",
          width: "100%",
          type: "line"
        },
        xaxis: {
          type: "datetime"
        },
        dataLabels: {
          enabled: true,
          position: 'top'
        },
        stroke: {
          curve: 'smooth'
        },
      }
    },
    stock: [],


    crecimientoMes: {},

    ganancias: {
      costoVendido: 0,
      totalVendido: 0,
      series: [{
        name: 'costo de lo Vendido',
        data: []
      }, {
        name: 'monto total Vendido',
        data: []
      }],
      chartOptions: {
        colors: ['#FF1744', '#00E676'],
        chart: {
          type: 'bar',
          height: '90%'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
          },
        },
        dataLabels: {
          enabled: true,
          position: 'top'
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['',''],
        },
        legend: {
          show: true
        },        

        // yaxis: {
        //   title: {
        //     text: '$ (thousands)'
        //   }
        // },
        fill: {
          opacity: 1,
        },
        // tooltip: {
        //   y: {
        //     formatter: function (val) {
        //       return "$ " + val + " thousands"
        //     }
        //   }
        // }
      },
    },

    totalNotasCredito: {
      total: 0,
      series: [
        {
          name: "Total Vendido",
          data: []
        }
      ],
      chartOptions: {
        chart: {
          height: "100%",
          width: "100%",
          type: "line"
        },
        xaxis: {
          type: "datetime"
        },
        dataLabels: {
          enabled: true,
          position: 'top'
        },
        stroke: {
          curve: 'smooth'
        },
      }
    },

    totalNotasDebito: {
      total: 0,
      series: [
        {
          name: "Total Vendido",
          data: []
        }
      ],
      chartOptions: {
        chart: {
          height: "100%",
          width: "100%",
          type: "line"
        },
        xaxis: {
          type: "datetime"
        },
        dataLabels: {
          enabled: true,
          position: 'top'
        },
        stroke: {
          curve: 'smooth'
        },
      }
    },

  }),

  created () {
    Api.get("empresa/dashboards")
      .then(res => {
        this.loadingInicio = false
        if (true) {
          // falta validar que si el mes actual es igual al creado
          // no mostrar grafico

          this.crecimientoMes = res.data.crecimientoMes[0]
        }
      })
      .catch(err => console.warn(err));    
  },


  methods: {
    changeFecha() {
      let hoy = this.$moment(this.date);
      switch (this.selectedDate) {
        case 1:
          this.fechaDesde = hoy.format("YYYY-MM-DD");
          this.fechaHasta = hoy.format("YYYY-MM-DD");
          this.buscar();
          break;
        case 2:
          this.fechaDesde = hoy.subtract(1, "d").format("YYYY-MM-DD");
          this.fechaHasta = this.fechaDesde;
          this.buscar();
          break;
        case 3:
          this.fechaHasta = hoy.format("YYYY-MM-DD");
          this.fechaDesde = hoy.subtract(7, "d").format("YYYY-MM-DD");
          this.buscar();
          break;
        case 4:
          this.fechaHasta = hoy.format("YYYY-MM-DD");
          this.fechaDesde = hoy.subtract(30, "d").format("YYYY-MM-DD");
          let fecha2 = hoy.subtract(30, "d");
          let prueba = fecha2.diff(hoy, "days");
          this.buscar();
          break;
        case 5:
          this.fechaHasta = "";
          this.fechaDesde = "";
          break;
      }
    },

    validarFecha() {
      let hoy = this.$moment(this.date);
      let desde = this.$moment(this.fechaDesde);
      let hasta = this.$moment(this.fechaHasta);
      this.graficas = true;
      if (desde > hasta) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Error al escoger el rango de las fechas."
        });
        return true;
      }
      if (hasta._i === hoy._i || hasta._i === hoy.subtract(1, "d")._i) {
        if (desde._i === hoy._i || desde._i === hoy.subtract(1, "d")._i) {
          this.graficas = false;
        }
      }
      return false;
    },

    buscar() {
      this.loading = true
      let fecha1 = this.$moment(this.fechaDesde) 
      let fecha2 = this.$moment(this.fechaHasta)
      this.rango = fecha2.diff( fecha1, 'days')
      if (!this.validarFecha()) {
        this.totalVentasRealizadas.total = 0;
        this.montoTotalVendido.total = 0;
        this.totalVentasRealizadas.series.data = [];
        Api.get("empresa/dashboards/" + this.fechaDesde + "/" + this.fechaHasta)
          .then(res => {
            this.productosMasVendidos = res.data.productosMasVendidos;
            this.productosMenosVendidos = res.data.productosMenosVendidos;
            this.stock = res.data.stock;

            if (res.data.totalVentasRealizadas.length > 0) {
              this.totalVentasRealizadas.total =
                res.data.totalVentasRealizadas[0].total;
              this.totalVentasRealizadas.series[0].data =
                res.data.totalVentasRealizadas[0].series;
            }


            if (res.data.totalNotasEntregaRealizadas.length > 0) {
              this.totalNotasEntregaRealizadas.total =
                res.data.totalNotasEntregaRealizadas[0].total;
              this.totalNotasEntregaRealizadas.series[0].data =
                res.data.totalNotasEntregaRealizadas[0].series;
            }

            if (res.data.montoTotalVendido.length > 0) {
              this.montoTotalVendido.total =
                res.data.montoTotalVendido[0].total;
              this.montoTotalVendido.series[0].data =
                res.data.montoTotalVendido[0].series;
            }

            if (res.data.ganancias.totalVendido) {
              this.ganancias.costoVendido = res.data.ganancias.costoVendido
              this.ganancias.totalVendido = res.data.ganancias.totalVendido
              this.ganancias.series[0].data[0] = (res.data.ganancias.costoVendido)
              this.ganancias.series[1].data[0] = (res.data.ganancias.totalVendido)
              this.ganancias.chartOptions.xaxis[0] = this.fechaDesde
              this.ganancias.chartOptions.xaxis[1] = this.fechaHasta
            }

            if (res.data.totalNotasDebito.length > 0) {
              this.totalNotasDebito.total =
                res.data.totalNotasDebito[0].total;
              this.totalNotasDebito.series[0].data =
                res.data.totalNotasDebito[0].series;
            }

            if (res.data.totalNotasCredito.length > 0) {
              this.totalNotasCredito.total =
                res.data.totalNotasCredito[0].total;
              this.totalNotasCredito.series[0].data =
                res.data.totalNotasCredito[0].series;
            }                                    

            this.loading = false

          })
          .catch(err => console.warn(err));
      }
    }
  }
};
</script>

<style lang="scss">
.base {
  background-color: #eeeeee;
  .v-card {
    margin-bottom: 8% !important;
  }
}

.ganancia {
  color: green;
}

.perdida {
  color: red;
}
</style>
